import { render, staticRenderFns } from "./Exposicoes.vue?vue&type=template&id=37c1b1cc&scoped=true&"
import script from "./Exposicoes.vue?vue&type=script&lang=ts&"
export * from "./Exposicoes.vue?vue&type=script&lang=ts&"
import style0 from "./Exposicoes.vue?vue&type=style&index=0&id=37c1b1cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c1b1cc",
  null
  
)

export default component.exports